export const getWidgetId = async (editorSDK, componentRef) => {
    const controllerData = await editorSDK.controllers.getData('token', {
        controllerRef: componentRef,
    });
    return controllerData.config.type;
};
export const getDevCenterWidgetId = async (editorSDK, componentRef) => {
    const controllerData = await editorSDK.controllers.getData('token', {
        controllerRef: componentRef,
    });
    return controllerData?.config?.devCenterWidgetId;
};
//# sourceMappingURL=widgetUtils.js.map